module.exports = __webpack_public_path__ + "static/media/30-49women.62bc8053.svg";